<template>
  <div :class="{ selected: value === data }" class="radio-item" @click="$emit('input', data)">
    <slot />
    <div class="radio-circle">
      <i class="anyteachicon anyteach-check" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "data"]
}
</script>


<style lang="scss" scoped>
@import "../../../../../static/css/transaction.scss";
.content {
  display: flex;
  align-items: center;
  margin: 0 0 5px 0;

  i {
    font-size: 35px;
    line-height: 1;
    margin-right: 8px;
  }

  .text {
    h4 {
      font-size: 0.75rem;
      opacity: 0.6;
      font-weight: 400;
      margin: 0;
    }
  }
}

.radio-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 5px 0;
  &:last-of-type {
    margin: 0;
  }
}

.selected {
  .radio-circle {
    background: $blue;
    border-color: $blue;
  }
}

.radio-circle {
  $size: 20px;
  width: $size;
  height: $size;
  border-radius: 100%;
  border: 1px solid #d7d7d7;
  background: #ededed;
  font-size: 12px;
  color: #ededed;
  position: relative;
  transition: 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>